import { KeyboardEvent, SyntheticEvent } from 'react';
import styles from './CheckBoxField.module.css';

interface CheckBoxFieldProps {
  isChecked: boolean;
  label: string;
  clickHandler?: (event: SyntheticEvent) => void;
  subLabel?: string;
}

export const CheckBoxField = ({ isChecked, label, clickHandler, subLabel }: CheckBoxFieldProps) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      clickHandler?.(event);
    }
  };

  // Only interactive when a handler is supplied; otherwise it is a read-only indicator.
  const interactiveProps = clickHandler
    ? {
        role: 'checkbox',
        'aria-checked': isChecked,
        tabIndex: 0,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
      }
    : {};

  return (
    <div className={`p-1 clearfix mt-1 ${clickHandler ? styles.clickable : ''}`} {...interactiveProps}>
      <div className="float-start">
        {isChecked ? (
          <span className={`${styles.checkboxselected} material-icons mx-2`} aria-hidden="true">check_box</span>
        ) : (
          <span className={`${styles.uncheckedIcon} material-icons mx-2`} aria-hidden="true">check_box_outline_blank</span>
        )}
      </div>
      <div className={`float-start ${styles.labelWrap}`}>
        <div className={styles.label}>{label}</div>
        {subLabel && (
          <div className={styles.subLabel}>{subLabel}</div>
        )}
      </div>
    </div>
  );
};
